import { TRootStatus } from "../../types/ux/status.ux.type";
import {
  requestRouteStatusModal,
  requestStatusModal,
} from "./statusRequests.mapping";

export declare type TCommonHelperStatus = {
  label: string;
  items: TRootStatus[];
};

declare type THelperStatus = {
  [key: string]: TCommonHelperStatus;
};

const requestStatusItems = Object.keys(requestStatusModal).map(
  (key) => ({ key, ...requestStatusModal[key] } as TRootStatus)
);
const requestRouteStatusItems = Object.keys(requestRouteStatusModal).map(
  (key) => ({ key, ...requestRouteStatusModal[key] } as TRootStatus)
);

export const helperStatusType: THelperStatus = {
  REQUEST: {
    label: "Estados:",
    items: requestStatusItems,
  } as TCommonHelperStatus,
  REQUEST_ROUTE: {
    label: "Estados:",
    items: requestRouteStatusItems,
  } as TCommonHelperStatus,
};
